module.exports = __webpack_public_path__ + "img/DSC01889 (2).cb281830.jpg";